import infoGreen from 'assets/images/account-page/info-green.svg';
import leadAutomatorAnnualIcon from 'assets/images/plan-lead-annual.svg';
import marketingAnnualIcon from 'assets/images/plan-marketing-annual.svg';
import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPlanDetails, updateSelectedChooseTierTooltip } from "../../../../data/user";
import css from "../style.scss";

const AnnualEssentialsIncludes = () => {
    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();
    const containerRef = useRef(null);

    const handleTooltipToggle = (tooltipId) => {
        const tooltipComponentId = `annualEssentials-${tooltipId}`;
        dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
    };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);
    return (
        <div className={css.clsInfoPopup} ref={containerRef}>
            <li>
                <img src={leadAutomatorAnnualIcon} className={css.clsIncludesIcon} alt="Lead Automator Bonus" />
                <b>Lead Automator Bonus: </b>
                2 Months Free
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('lead')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'annualEssentials-lead',
                })} style={{ left: '10%', bottom: '72%' }}>
                    <h6 className={css.clsInfoContentTitle}>Lead Automator Bonus <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>($52 Value) Automatically track and get updates on 50,000 properties with custom filters. Lead Automator works for you to identify new leads that match your designated criteria while flagging previously saved leads that no longer do.</p>
                </div>
            </li>
            <li>
                <img src={marketingAnnualIcon} className={css.clsIncludesIcon} alt="Marketing Credit Bonus" />
                <b>Marketing Credit Bonus: </b>
                {" "}
                $100
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('marketing')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'annualEssentials-marketing',
                })} style={{ left: '77%', bottom: '25%' }}>
                    <h6 className={css.clsInfoContentTitle}>Marketing Credit Bonus <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>This one time marketing credit can help simplify your outreach with credits you can use for skip tracing, emails, or postcards. It’s a flexible way to connect with leads and keep your marketing efforts moving forward.</p>
                </div>
            </li>
        </div>
    )
}

export default AnnualEssentialsIncludes;
